const isAuthenticated = () => Boolean(sessionStorage.getItem('token'));

export default isAuthenticated;
